import { ShelfDeck } from '@/shared/types/configurator';
import { ToolbarConfiguratorUsedOptions } from '../types/toolbar.types';

export const DEFAULT_USED_OPTIONS: ToolbarConfiguratorUsedOptions = {
	height: [],
	width: [],
	depth: [],
	levels: [],
	deck: {
		[ShelfDeck.GALVANIZED_METAL]: 0,
		[ShelfDeck.LAMINATED_PARTICLE_BOARD]: 0,
		[ShelfDeck.PAINTED_METAL]: 0,
		[ShelfDeck.SANDED_PARTICLE_BOARD]: 0,
	},
};
